import React, { FC } from "react";
import config from "../../package.json";

interface IProps {
  branding: Branding;
  name: string;
}

const SideNavFooter: FC<IProps> = ({ branding, name }) => {
  return (
    <div className="sidenav-footer">
      {branding?.black_logo && (
        <img className="sidenav-logo" src={branding && branding.black_logo} alt={`${name} Logo`} />
      )}
      <p className="sidenav-version">version (A) {config.version}</p>
    </div>
  );
};
export default SideNavFooter;
